'use strict';

import FieldView from 'views/record/Field';

class PrintSettingsField extends FieldView {
}

export default PrintSettingsField;